






















import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import { TeacherService } from '../../../biz/remote/TeacherService';
import DialgoHeader from './DialgoHeader.vue';

import CommonCalendar, { CalendarEvent, DateClickEvent, EventColor } from '../../../components/organisms/CommonCalendar.vue';
import { LessonListDTO } from '../../../../src_server/entity/dto/LessonListDTO';
import { Teacher } from '../../../../src_server/entity/generated/Teacher';
import { Session } from '../../../utils/Session';
import { LessonStates } from '../../../../src_server/entity/master/LessonStates';
import { MessageDialog } from '../../../utils/MessageDialog';
import LessonRequestDialog from './LessonRequestDialog.vue';

import { dayjs, DT_FORMAT, DT_FORMAT_INPUT } from '../../../../src_server/common/momentExtends';

@Component({ components: { CommonDialog, CommonCalendar, DialgoHeader, LessonCalendarDialog, LessonRequestDialog } })
export default class LessonCalendarDialog extends Vue {
  private dto = new LessonListDTO();

  public async show(teacher_user_id: string) {
    const tbiz = new TeacherService();
    const response = await tbiz.getTeacherAllInfo(teacher_user_id);

    this.dto = response.data;
    (this.$refs['LessonCalendarDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['LessonCalendarDialog'] as CommonDialog).hide();
  }

  //カレンダーに表示するイベント
  get calendarEvents(): CalendarEvent[] {
    let calendarEvents: CalendarEvent[] = [];
    calendarEvents = this.dto.schedules.map((sdto) => {
      const s = sdto.shiftTable;
      const start = dayjs(s.start_time).format(DT_FORMAT_INPUT);
      const end = dayjs(s.end_time).format(DT_FORMAT_INPUT);
      return {
        title: '可能日',
        start: start,
        end: end,
        id: s.shift_table_id,
        backgroundColor: EventColor.SCHEDULE,
        type: 'teacher_enable',
      } as CalendarEvent;
    });

    const myLessons = this.dto.commitedLessons.map((c) => {
      if (c.student_user_id === Session.getSessionUserId()) {
        switch (c.reservation_state) {
          case LessonStates.COMMIT:
            return {
              title: 'あなたの予約',
              start: c.start_dt?.toLocaleString() || '',
              end: c.end_dt?.toLocaleString() || '',
              backgroundColor: EventColor.RESERVATION_REQ,
              type: 'request',
            } as CalendarEvent;
          case LessonStates.TRANSFAR:
            return {
              title: '振替依頼',
              start: c.start_dt?.toLocaleString() || '',
              end: c.end_dt?.toLocaleString() || '',
              backgroundColor: EventColor.TRANSFER,
              type: 'request',
            } as CalendarEvent;
          case LessonStates.ALREADY:
            return {
              title: '実施済',
              start: c.start_dt?.toLocaleString() || '',
              end: c.end_dt?.toLocaleString() || '',
              backgroundColor: EventColor.DONE,
              type: 'request',
            } as CalendarEvent;
          default:
            return {
              title: 'あなたの予約依頼',
              start: c.start_dt?.toLocaleString() || '',
              end: c.end_dt?.toLocaleString() || '',
              backgroundColor: EventColor.RESERVATION_REQ,
              type: 'request',
            } as CalendarEvent;
        }
      } else {
        return {
          title: 'ほかの人の予約',
          start: c.start_dt?.toLocaleString() || '',
          end: c.end_dt?.toLocaleString() || '',
          backgroundColor: EventColor.ANOTER_RESERVATION,
          type: 'request',
        } as CalendarEvent;
      }
    });
    calendarEvents = calendarEvents.concat(myLessons);
    return calendarEvents;
  }

  get teacher() {
    return this.dto.teacher;
  }

  async eventClick(e: any) {
    console.log(e.event);
    const event = e.event;
    const date = event.start;

    const limitDate = 0;
    if (dayjs().diff(dayjs(date)) > 0) {
      await MessageDialog.alert('過去の日時は予約できません。');
      return;
    }
    if (dayjs().add(limitDate, 'd').diff(dayjs(date)) > 0) {
      await MessageDialog.alert(`予約は${limitDate}日以降から可能です。`);
      return;
    }
    (this.$refs['LessonRequestDialog'] as LessonRequestDialog).show(this.dto, date);
    this.$emit('date-click', event);
  }

  async handleDateClick(arg: DateClickEvent) {
    // const limitDate = 0;
    // if (dayjs().diff(dayjs(arg.date)) > 0) {
    //   await MessageDialog.alert('過去の日時は予約できません。');
    //   return;
    // }
    // if (dayjs().add(limitDate, 'd').diff(dayjs(arg.date)) > 0) {
    //   await MessageDialog.alert(`予約は${limitDate}日以降から可能です。`);
    //   return;
    // }
    // this.$emit('date-click', arg);
  }
}
